// extracted by mini-css-extract-plugin
module.exports = {"grid":"favorites-list_grid__jqyIK"};